import React from "react";
import { Header, Footer, Sidebar } from "./";

const Layout = ({
  children,
  navbarStyle,
  leadFormController,
}: {
  children: React.ReactNode;
  navbarStyle?: "logo_only";
  leadFormController: string;
}) => {
  return (
    <div className="overflow-x-hidden">
      <Header navbarStyle={navbarStyle} />
      <Sidebar />
      <main>{children}</main>
      <Footer dontUseLeadForm={leadFormController === "off"} />
    </div>
  );
};

export default Layout;
